import { Card, CardContent } from "@/components/ui/library/card";
import { Separator } from "@/components/ui/separator";
import FullScreenLoader from "@/components/feedback/full-screen-loader/FullScreenLoader";
import useActiveIndustryData from "../hook/useActiveIndustryData";
import { StageDrawerHeader } from "./StageDrawerHeader";
import useIndexChilOverview from "../hook/useIndexChilOverview";
import { useChildForm } from "@/features/leads/contexts/ChildProvider";
import { useAppSelector } from "@/stores/hook";

export default function StageDrawerRoute() {
  const { stageId } = useAppSelector((state) => state.childFunctional);
  const { lead, smartRoute } = useActiveIndustryData();
  const { currentChildsOnSelectedStage, childsLoading } = useChildForm();
  const ChildOverview = useIndexChilOverview();

  const buttonDisabled = stageId !== lead?.stage?.id;
  if (!lead || childsLoading) return <FullScreenLoader />;

  const handleAddDeal = () => {
    smartRoute();
  };

  return (
    <Card className="border-[var(--color-black-1)] rounded-[16px] shadow-none py-0">
      <CardContent className="py-3">
        {currentChildsOnSelectedStage?.length ? (
          <StageDrawerHeader
            count={currentChildsOnSelectedStage.length}
            onClick={handleAddDeal}
            disabled={buttonDisabled}
          />
        ) : null}
        <Separator className="my-4" />
        {ChildOverview}
      </CardContent>
    </Card>
  );
}
